import React, { FC } from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { FormattedMessage } from "react-intl";

interface ItemProps {
  imageclass: string;
  link: string;
  title: string;
  description: string;
}

const WorkItem: FC<ItemProps> = ({ imageclass, link, title, description }) => {

  const goToSite = () => {
    window.open(link, "_target");
  }
  return (
    <div className="item-work" onClick={goToSite}>
      <div className={`bg-image ${imageclass}`}>
        <p className="view-project">
          <FormattedMessage id="work.visit" defaultMessage="Visit" /> <BsArrowRightShort size="1.8em" />
        </p>
        <div className="overlay">
        </div>
      </div>
      <div className="description-prj">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default WorkItem;
